import React from 'react'

const privacyPolicy = () => {
  return (
    <div>privacyPolicy</div>
  )
}

export default privacyPolicy